import type { MenuProps } from "antd";

/**
 * AntD v5 MenuProps["items"] is ItemType[]
 * You must return SINGLE ItemType objects, not arrays.
 */

export const divider: NonNullable<MenuProps["items"]>[number] = { type: "divider" };

export function item(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode
): NonNullable<MenuProps["items"]>[number] {
  return { key, label, icon };
}

export function group(
  label: React.ReactNode,
  children: NonNullable<MenuProps["items"]>
): NonNullable<MenuProps["items"]>[number] {
  return { type: "group", label, children };
}
